// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import MultiSelectPillsController from "./multi_select_pills_controller"
application.register("multi-select-pills", MultiSelectPillsController)

import KeywordSuggestionController from "./keyword_suggestion_controller"
application.register("keyword-suggestion", KeywordSuggestionController)
